<template>
  <v-form
    ref="form"
    @submit.prevent="submit"
    v-model="formValid"
    class="containerInsuredForm2"
  >
    <v-row>
      <h3 class="black--text mb-4">Dados do Segurado</h3>
    </v-row>
    <v-row>
      <v-col cols="12" sm="2" class="pr-3">
        <BaseFormInput
          id-element="cpfCnpjInsuredQuotation"
          v-model="formInsured.numero_documento"
          hide-no-data
          item-text="numero_documento"
          item-value="numero_documento"
          label-text="CPF/CNPJ"
          :return-object="false"
          :template-insured="true"
          disabled
        />
      </v-col>
      <v-col cols="12" sm="7" class="pr-3">
        <BaseFormInput
          id-element="nameInsuredQuotation"
          v-model="formInsured.nome"
          label-text="Nome"
          hide-no-data
          item-text="nome"
          :return-object="false"
          :template-insured="true"
          disabled
        />
      </v-col>
      <v-col cols="12" sm="2" class="pr-3">
        <BaseFormSelect
          id-element="maritalStatusQuotation"
          placeholder=""
          label-text="Estado Civil"
          v-model="formInsured2.estado_civil"
          :items="maritalStatus"
          item-text="nome"
          item-value="id"
          required
          :rules="[requiredInput]"
          :return-object="true"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3" class="pr-3">
        <BaseFormInput
          id-element="date"
          v-model="formInsured2.data_nascimento"
          placeholder="DD/MM/YYYY"
          required
          :rules="[requiredInput, dateTermValid]"
          validate-on-blur
          v-facade="maskDate"
          label-text="Data de Nascimento"
        />
      </v-col>
      <v-col cols="12" sm="3" class="pr-3">
        <BaseFormSelect
          id-element="documentTypeQuotation"
          placeholder=""
          label-text="Gênero"
          v-model="formInsured2.genero"
          :items="genero"
          item-text="nome"
          item-value="sigla"
          required
          :rules="[requiredInput]"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="2" class="pr-0 pr-3">
        <BaseFormInput
          id-element="celularInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.celular"
          required
          :rules="[requiredInput]"
          validate-on-blur
          label-text="Celular"
          disabled
        />
      </v-col>
      <v-col cols="12" sm="3" class="pr-3">
        <BaseFormInput
          id-element="emailInsuredQuotation"
          v-model="formInsured.email"
          label-text="E-mail"
          disabled
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3" class="pr-3">
        <BaseFormSelect
          id-element="documentTypeQuotation"
          placeholder=""
          label-text="Tipo de Documento"
          v-model="formInsured2.tipo_documento"
          :items="documentType"
          item-text="nome"
          item-value="id"
          required
          :rules="[requiredInput]"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="3" class="pr-3">
        <BaseFormInput
          id-element="documentNumberQuotation"
          placeholder=""
          v-model="formInsured2.numero_documento_extra"
          required
          :rules="[requiredInput]"
          label-text="Número do Documento"
          hide-no-data
          item-text="nome"
          :return-object="false"
          :template-insured="true"
        />
      </v-col>
      <v-col cols="12" sm="3" class="pr-3">
        <BaseFormSelect
          id-element="agencyDispatcherQuotation"
          placeholder=""
          label-text="Órgão Expedidor/UF"
          :items="documentIssuance"
          item-value="id"
          item-text="nome"
          v-model="formInsured2.orgao_expedidor"
          required
          :rules="[requiredInput]"
          :returnObject="true"
        />
      </v-col>
      <v-col cols="12" sm="2" class="pr-3">
        <BaseFormInput
          id-element="expeditionDay"
          placeholder="DD/MM/YYYY"
          label-text="Data da Expedição"
          v-model="formInsured2.data_expedicao"
          v-facade="maskDate"
          required
          :rules="[requiredInput, dateTermValid]"
        />
      </v-col>
    </v-row>
    <v-row>
      <h3 class="black--text mb-4">Endereço</h3>
    </v-row>
    <v-row>
        <v-col cols="12" sm="4" class="pr-3">
          <BaseFormInput
            id-element="cepLocation"
            placeholder="Digite o Cep"
            required
            v-model="formInsured2.endereco.cep"
            :rules="[requiredInput, isValidCep]"
            validate-on-blur
            v-facade="maskCEP"
            label-text="CEP"
            :cep="cepInputClass"
          />
        </v-col>
        <v-col cols="12" sm="4" class="pr-3">
          <BaseFormInput
            id-element="cityLocation"
            placeholder=""
            required
            v-model="formInsured2.endereco.cidade"
            :rules="[requiredInput]"
            label-text="Município"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="3" class="pr-3">
          <BaseFormInput
            id-element="ufLocation"
            placeholder=""
            required
            :items="brazilianStates"
            v-model="formInsured2.endereco.uf.sigla"
            :rules="[requiredInput]"
            label-text="UF"
            item-text="nome"
            item-value="sigla"
            :return-object="true"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="3" class="pr-3">
          <BaseFormInput
            id-element="neighborhoodInsuredQuotation"
            placeholder=""
            v-model="formInsured2.endereco.bairro"
            label-text="Bairro"
            required
            :rules="[requiredInput]"
          />
        </v-col>
        <v-col cols="12" sm="3" class="pr-3">
          <BaseFormInput
            id-element="addressInsuredQuotation"
            placeholder=""
            v-model="formInsured2.endereco.logradouro"
            label-text="Endereço"
            required
            :rules="[requiredInput]"
          />
        </v-col>
        <v-col cols="12" sm="2" class="pr-0 pr-3">
          <BaseFormInput
            id-element="numberInsuredQuotation"
            placeholder=""
            v-model="formInsured2.endereco.numero"
            label-text="Número"
            type="number"
            required
            :rules="[requiredInput]"
          />
        </v-col>
        <v-col cols="12" sm="3" class="pr-3">
          <BaseFormInput
            id-element="complementInsuredQuotation"
            placeholder=""
            v-model="formInsured2.endereco.complemento"
            label-text="Complemento"
          />
        </v-col>
    </v-row>
    <v-row>
      <h3 class="black--text mb-4">Dados Bancários</h3>
    </v-row>
    <v-row cols="12">
      <v-col cols="12" sm="5" class="pr-3">
        <BaseFormAutocompleteSelectable
          id-element="bankingInstituitionInsured"
          placeholder=""
          v-model="formInsured2.dados_bancarios.banco"
          :items="listBankingInstitutions"
          label-text="Banco"
          item-text="nome"
          item-value="id"
          :return-object="true"
          clearable
        />
      </v-col>
      <v-col cols="12" sm="3" class="pr-3">
        <BaseFormInput
          id-element="numberInsuredQuotation"
          placeholder=""
          v-model="formInsured2.dados_bancarios.agencia"
          label-text="Agência"
          :rules="[dataBankRegex]"
          @keypress="handlePress($event)"
        />
      </v-col>
      <v-col cols="12" sm="3" md="3" class="pr-3">
        <BaseFormInput
          id-element="numberInsuredQuotation"
          placeholder=""
          v-model="formInsured2.dados_bancarios.conta"
          label-text="Conta"
          :rules="[dataBankRegex]"
          @keypress="handlePress($event)"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
const MARITAL_STATUS = [
  {
    id: "solteiro",
    nome: "Solteiro"
  },
  {
    id: "casado",
    nome: "Casado"
  },
  {
    id: "divorciado",
    nome: "Divorciado"
  },
  {
    id: "viuvo",
    nome: "Viúvo"
  },
  {
    id: "outros",
    nome: "Outros"
  }
];

const GENERO = [
  {
    sigla: "F",
    nome: "Feminino"
  },
  {
    sigla: "M",
    nome: "Masculino"
  }
];

const DOCUMENT_TYPE = [
  {
    id: "cie",
    nome: "CIE"
  },
  {
    id: "cnh",
    nome: "CNH"
  },
  {
    id: "cpm",
    nome: "CPM"
  },
  {
    id: "ic",
    nome: "IC"
  },
  {
    id: "im",
    nome: "IM"
  },
  {
    id: "passaporte",
    nome: "Passaporte"
  },
  {
    id: "rg",
    nome: "RG"
  },
  {
    id: "rne",
    nome: "RNE"
  }
];

const DOCUMENT_ISSUANCE = [
  {
    id: "DIC - RJ",
    nome: "DIC - RJ"
  },
  {
    id: "IFP – RJ",
    nome: "IFP – RJ"
  },
  {
    id: "MAE - MIN. DA AERONAUTICA",
    nome: "MAE - MIN. DA AERONAUTICA"
  },
  {
    id: "MEX - MIN. DO EXERCITO",
    nome: "MEX - MIN. DO EXERCITO"
  },
  {
    id: "MMA - MIN. DA MARINHA",
    nome: "MMA - MIN. DA MARINHA"
  },
  {
    id: "MT",
    nome: "MT"
  },
  {
    id: "PF - POLICIA FEDERAL",
    nome: "PF - POLICIA FEDERAL"
  },
  {
    id: "SSP - AC",
    nome: "SSP - AC"
  },
  {
    id: "SSP - AL",
    nome: "SSP - AL"
  },
  {
    id: "SSP - AM",
    nome: "SSP - AM"
  },
  {
    id: "SSP - AP",
    nome: "SSP - AP"
  },
  {
    id: "SSP - BA",
    nome: "SSP - BA"
  },
  {
    id: "SSP - CE",
    nome: "SSP - CE"
  },
  {
    id: "SSP - DF",
    nome: "SSP - DF"
  },
  {
    id: "SSP - ES",
    nome: "SSP - ES"
  },
  {
    id: "SSP - FN",
    nome: "SSP - FN"
  },
  {
    id: "SSP - GO",
    nome: "SSP - GO"
  },
  {
    id: "SSP - MA",
    nome: "SSP - MA"
  },
  {
    id: "SSP - MG",
    nome: "SSP - MG"
  },
  {
    id: "SSP - MS",
    nome: "SSP - MS"
  },
  {
    id: "SSP - MT",
    nome: "SSP - MT"
  },
  {
    id: "SSP - PA",
    nome: "SSP - PA"
  },
  {
    id: "SSP - PB",
    nome: "SSP - PB"
  },
  {
    id: "SSP - PE",
    nome: "SSP - PE"
  },
  {
    id: "SSP - PI",
    nome: "SSP - PI"
  },
  {
    id: "SSP - PR",
    nome: "SSP - PR"
  },
  {
    id: "SSP - RJ",
    nome: "SSP - RJ"
  },
  {
    id: "SSP - RN",
    nome: "SSP - RN"
  },
  {
    id: "SSP - RO",
    nome: "SSP - RO"
  },
  {
    id: "SSP - RR",
    nome: "SSP - RR"
  },
  {
    id: "SSP - RS",
    nome: "SSP - RS"
  },
  {
    id: "SSP - SC",
    nome: "SSP - SC"
  },
  {
    id: "SSP - SE",
    nome: "SSP - SE"
  },
  {
    id: "SSP - SP",
    nome: "SSP - SP"
  },
  {
    id: "SSP - TO",
    nome: "SSP - TO"
  }
];

import {
  requiredInput,
  isValidCep,
  dateTermValid,
  dataBankRegex
} from "@/utils/rules.js";
import { maskCEP } from "@/utils/masks.js";
import { brazilianStates } from "@/utils/utils.js";
import { maskDate } from "@/utils/masks.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CompanyMixin from "@/mixins/CompanyMixin";

export default {
  data: () => ({
    formValid: true,
    requiredInput,
    dataBankRegex,
    isValidCep,
    maskCEP,
    brazilianStates,
    maskDate,
    dateTermValid,
    maritalStatus: MARITAL_STATUS,
    documentType: DOCUMENT_TYPE,
    documentIssuance: DOCUMENT_ISSUANCE,
    showCepErro: false,
    genero: GENERO
  }),
  created() {
    this.requestBankingInstitutions();
  },
  computed: {
    ...mapState(["loadingStatus"]),
    ...mapState("quotation", ["listBankingInstitutions", "addressApi"]),
    cepInputClass() {
      return this.showCepErro ? "red-border-class" : "";
    },
    formInsured2: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  mixins: [LoadingRequest, CompanyMixin],
  methods: {
    ...mapActions("quotation", [
      "requestBankingInstitutions",
      "requestAddressApi"
    ]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    handlePress(e) {
      if (!e.key.match(/^[a-zA-Z0-9]*$/)) {
        e.preventDefault();
      }
    },
    async fetchAddressApi(value) {
      const cep = value.replace(/[^0-9]/g, "");
      try {
        const result = await this.withLoading(this.requestAddressApi(cep));
        if (this.formInsured2.endereco.cidade != result.cidade?.toUpperCase()) {
          this.formInsured2.endereco.cidade = result.cidade?.toUpperCase();
          this.formInsured2.endereco.uf.sigla = result.uf.sigla;
          this.formInsured2.endereco.bairro = result.bairro?.toUpperCase();
          this.formInsured2.endereco.logradouro = result.logradouro?.toUpperCase();
          this.formInsured2.endereco.complemento = result.complemento?.toUpperCase();
        }
      } catch (error) {
        console.error(error);
      }
    },
    cancelQuotation() {
      this.$emit("cancel");
    },
    validate() {
      if (this.$refs.form.validate()) {
        if (!this.formInsured2.endereco.cep) {
          this.showCepErro = true;
          return false;
        }
        return true;
      }
      return false;
    }
  },
  props: {
    value: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    formInsured: {
      type: Object
    },
    formLocation: {
      type: Object
    }
  },
  watch: {
    "formInsured2.endereco.cep": {
      handler(newVal, oldVal) {
        if (
          newVal != null &&
          oldVal != null &&
          newVal !== oldVal &&
          newVal.length == 9
        ) {
          this.fetchAddressApi(newVal);
        }
      }
    }
  }
};
</script>

